import React from "react";
import ME from "../assets/img/ME.jpg";

function About() {
    return (
        <section id="about">
            <h5>Get to know</h5>
            <h2>About Me</h2>

            <div className="about_container">
                <div className="about_header">
                    <div className="about_image">
                        <img src={ME} alt="about me" />
                    </div>
                    <p>
                        Hey there, I'm Ashiq Noor Sudheer, a tech-savvy individual with a passion for web development, AI, and machine learning. As a fourth-year undergraduate, I have immersed myself in these fields and am always on the lookout for new challenges to tackle. I bring a unique combination of technical skills and creative flair to the table. 
                    </p>
                    <a href="#contact" className="btn1 btn-primary">Let's talk</a>
                </div>

                <div className="about_content">    
                    <div className="about_section">
                        <h2>Education</h2>
                        <ul>
                            <li>
                                B.Tech Computer Science and Engineering<br />
                                <span className="edu-institute">Vellore Institute of Technology | CGPA: 9.68</span>
                            </li>
                            <li>
                                AISSCE (Grade XII)<br />
                                <span className="edu-institute">Sharjah Indian School | Percentage: 97.2</span>
                            </li>
                            <li>
                                AISSCE (Grade X)<br />
                                <span className="edu-institute">Sharjah Indian School | Percentage: 95</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;
